import React from "react";
import "./Header.css"; // Create a CSS file for styling

const Header = () => {
  return <div className="header">Pick Users</div>;
};

export default Header;
